import React, { useState, useEffect } from "react";
import "./Allannouncement .css";

const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Later you can replace this with your API call
  useEffect(() => {
    // Simulated API response
    const fetchNotifications = async () => {
      try {
        // Example: const res = await fetch("https://api.example.com/notifications");
        // const data = await res.json();

        const data = [
          {
            id: 1,
            title: "Upcoming Member Meeting",
            date: "Sun, Mar 10, 2024",
            priority: "high",
            tag: "Meeting",
            description:
              "Join us for our monthly member meeting on Saturday, March 16th at 2:00 PM. We'll be discussing important policy updates and upcoming initiatives.",
            unread: true,
          },
          {
            id: 2,
            title: "New Mobilization Campaign Launch",
            date: "Sun, Mar 10, 2024",
            priority: "medium",
            tag: "Campaign",
            description:
              "We're excited to announce our new voter outreach campaign. Members are encouraged to participate in canvassing activities starting this weekend.",
            unread: true,
          },
        ];

        setNotifications(data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  // Mark a notification as read
  const markAsRead = (id) => {
    setNotifications(
      notifications.map((n) =>
        n.id === id ? { ...n, unread: false } : n
      )
    );
  };

  if (loading) {
    return <p className="loading">Loading notifications...</p>;
  }

  return (
    <div className="announcements-container">
      <h2 className="page-title">🔔 Announcements</h2>
      <div className="unread-badge">
        {notifications.filter((n) => n.unread).length} Unread Message
      </div>

      {notifications.length === 0 ? (
        <p className="empty">No announcements available.</p>
      ) : (
        notifications.map((note) => (
          <div
            key={note.id}
            className={`notification-card ${note.priority} ${
              note.unread ? "unread" : ""
            }`}
          >
            <div className="notification-header">
              <h3>{note.title}</h3>
              <span className="date">{note.date}</span>
            </div>
            <div className="tags">
              <span className={`priority ${note.priority}`}>
                {note.priority}
              </span>
              <span className="tag">{note.tag}</span>
            </div>
            <p className="description">{note.description}</p>
            <div className="actions">
              {/* <button className="view-btn">View Details</button> */}
              {note.unread && (
                <button
                  className="mark-btn"
                  onClick={() => markAsRead(note.id)}
                >
                  Mark As Read
                </button>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Notification;
